import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
const base = (tenantId: string | number) => `${env.apiTasklistBaseUrl}/api/v1/compro/kpis/${tenantId}`;

export interface KpiCreatePayload {
  org_chart_node_id: number;
  kpi: {
    org_job_description_id: number;
    satuan: string;
    target_kpi: string;
    definisi_target: string;
    target: number | string;
    realisasi: number | string;
    bobot?: number;
  };
}

export async function getKpis(tenantId: string | number, params?: Record<string, unknown>) {
  const { data } = await axiosInstance.get(base(tenantId), { params });
  return data;
}

export async function getKpiDetail(tenantId: string | number, id: string | number) {
  const { data } = await axiosInstance.get(`${base(tenantId)}/${id}`);
  return data;
}

export async function createKpi(tenantId: string | number, payload: KpiCreatePayload) {
  const { data } = await axiosInstance.post(base(tenantId), payload);
  return data;
}

export async function updateKpi(tenantId: string | number, id: string | number, payload: KpiCreatePayload) {
  const { data } = await axiosInstance.put(`${base(tenantId)}/${id}`, payload);
  return data;
}

export async function deleteKpi(tenantId: string | number, id: string | number) {
  const { data } = await axiosInstance.delete(`${base(tenantId)}/${id}`);
  return data;
}

export type { IOrgKPI } from '@/types/kpi.types';
